export default __webpack_public_path__ + "static/media/correct.23d0e138.mp3";